<template>
  <div class="bg-white rounded-lg shadow p-5 flex items-center gap-4 text-left">
    <div class="w-12 h-12 rounded-full flex items-center justify-center shrink-0" :class="iconBg">
      <span class="material-symbols-outlined" :class="iconColor">{{ icon }}</span>
    </div>
    <div class="min-w-0 text-left">
      <p class="text-sm text-gray-500 text-left leading-tight">{{ label }}</p>
      <p class="text-2xl font-bold text-gray-800 text-left leading-tight mt-0.5">
        {{ loading ? '—' : value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminStatCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: 0
    },
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'blue'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconBg() {
      const map = {
        blue: 'bg-blue-100',
        yellow: 'bg-yellow-100',
        green: 'bg-green-100'
      };
      return map[this.color] || map.blue;
    },
    iconColor() {
      const map = {
        blue: 'text-blue-800',
        yellow: 'text-yellow-700',
        green: 'text-green-700'
      };
      return map[this.color] || map.blue;
    }
  }
};
</script>
